import * as React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import moment from 'moment';
import styles from './campaignSummary.module.scss'
import Paper from '../Paper';
import { useSelector } from 'react-redux';
import { CAMPAIGN_STATUSES, CAMPAIGN_STATUSES_COLOR, campaignCTAs, events } from "../../utils/constants"
import { getPeriscopeURL } from '../../utils/utils';
import { steps } from '../../containers/CreateCampaigns/constants';
import { getComment } from '../../containers/CreateCampaigns/helpers';
import { sendEvents } from '../../utils/events';
import CampaignInfoTable from './CampaignInfoTable';

const CampaignSummary = ({ onEdit, onSubmit, onPause, onResume }) => {
  const { summary } = useSelector(store => store.campaignSummary)
  const { campaignId, possibleCTAs = [], stateTransitionDTOList = [], allowedFeatures = [], campaignStatus = '' } = summary;
  const comment = getComment(summary);
  let [currentTab, setCurrentTab] = React.useState(0)
  let showTabs = false
  let src = ""
  const bannerInputExists = summary.bannerInput
  const jpinsExists = summary.hasOwnProperty('jpins') ? summary.jpins : (summary.jpinsOnBanner?.length > 0)
  const START_TIME = summary.startTime;
  const END_TIME = summary.endTime;
  if ([CAMPAIGN_STATUSES.live, CAMPAIGN_STATUSES.dead, CAMPAIGN_STATUSES.scheduled].includes(campaignStatus)) {
    showTabs = true
    src = 'https://prod-apnortheast-a.online.tableau.com/#/site/jtgrowth/views/SantaCampaignPerformanceTracking/SantaTrackingV1?:iid=2'
  }

  React.useEffect(() => {
    if (summary) {
      sendEvents(events.VIEW_CAMPAIGN_SUMMARY, { summary });
    }
  }, [summary]);
  
  const onClickCTA = (button) => {
    sendEvents(events.BUTTON_CLICK, { button, campaignId: summary.campaignId, campaignData: summary || null })
    switch(button) {
      case campaignCTAs.edit:
        if (allowedFeatures.length > 0) {
          onEdit(steps.indexOf(allowedFeatures[0])); //incase of campaign is already there
        } else {
          onEdit(0);
        }
        break;
      case campaignCTAs.editRequest: {
        onEdit(0);
        break;
      }
      case campaignCTAs.uploadBanner:
      case campaignCTAs.editBanner: {
        onEdit(3);
        break;
      }
      case campaignCTAs.addDetails: {
        onEdit(4);
        break;
      }
      case campaignCTAs.submitRequest:
      case campaignCTAs.sendForApproval:
      case campaignCTAs.schedule:
      case campaignCTAs.update: {
        onSubmit(button);
        break;
      }
      case campaignCTAs.decline:
        onSubmit(button);
        break;
      case campaignCTAs.pause:
        onPause(summary);
        break;
      case campaignCTAs.resume:
        onResume(summary);
        break;
      default: {
        break;
      }
    }
  }
  
  return (
    <Grid container className={styles.campaginSummaryContainer}>
      <Grid container item className={styles.headingContainer} justifyContent="space-between" alignItems="center" marginTop={"10px"}>
        <Grid item xs={3}>{"Summary of your Campaign"}</Grid>
        <Grid item xs={3} textAlign="right">
          Campaign status : <span style={{
            color: CAMPAIGN_STATUSES_COLOR[campaignStatus]
          }}>{campaignStatus}</span>
        </Grid>
      </Grid>
      <Paper p="5px 26px 0px">
        <Grid container alignItems="center" sx={{ bgcolor: "#E5E5E5" }}>
          {showTabs && <Grid container item xs={6}>
            <Grid item xs={2}
              className={`${styles.summaryTab} ${currentTab === 0 ? styles.tabSelected : ""}`}
              onClick={() => {
                setCurrentTab(0)
              }}>
              <Typography>Summary</Typography>
            </Grid>
            <Grid item xs={2}
              className={`${styles.summaryTab} ${currentTab === 1 ? styles.tabSelected : ""}`}
              onClick={() => {
                sendEvents(events.VIEW_CAMPAIGN_ANALYTICS);
                setCurrentTab(1)
              }}>
              <Typography>Analytics</Typography>
            </Grid>
          </Grid>}
        </Grid>
      </Paper>
      {currentTab === 0 && <>
        <Paper className={styles.paperContainer}>
          <Grid container className={styles.summaryContainer} justifyContent="space-between" alignItems="center">
            <Grid item xs={12} className={styles.summaryContainerRow}>
                <Typography className={styles.heading}>Campaign Goal</Typography>
                <Typography marginTop={'10px'} className={styles.text}>{summary.goal}</Typography>
            </Grid>
            <Grid item xs={12} container className={styles.summaryContainerRow} justifyContent="space-between">
              <Grid item xs={6}>
                <Typography className={styles.heading}>Campaign Name</Typography>
                <Typography marginTop={'10px'} className={styles.text}>{summary.campaignName}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={styles.heading}>Campaign Duration</Typography>
                <Typography marginTop={'10px'}className={styles.text}>{new Date(START_TIME).toLocaleDateString()} - {new Date(END_TIME).toLocaleDateString()}</Typography>
              </Grid>
            </Grid> 
          </Grid>
        </Paper>
        <Paper className={styles.paperContainer}>
          <Grid container className={styles.summaryContainer}>
            <Grid item container className={styles.summaryContainerRow} justifyContent="space-between">
              <Grid item xs={3}>
                <Typography className={styles.heading}>Customer Segment</Typography>
              </Grid>
              <Grid item xs={1} />
            </Grid>
            <Grid item container className={styles.summaryContainerRow} justifyContent="space-between">
              <Grid item xs={3}>
                <Typography className={styles.text}>{summary.customerSegmentQuery}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Paper className={styles.paperContainer}>
          <Grid container className={styles.summaryContainer}>
            <Grid item container className={styles.summaryContainerRow} justifyContent="space-between">
              <Grid item xs={3}>
                <Typography className={styles.heading}>Product Selection</Typography>
              </Grid>
            </Grid>
            <Grid item container className={styles.summaryContainerRow} justifyContent="space-between">
              <Grid item xs={5}>
                <Typography className={styles.text}>{summary.productQuery}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Paper className={styles.paperContainer}>
          <Grid container className={styles.summaryContainer}>
          <Grid container item xs={8}>
            <Grid item xs={6} className={styles.summaryContainerRow}>
                <Typography className={styles.heading}>Banner Callout</Typography>
                { bannerInputExists ? 
                <Typography marginTop={'10px'} className={styles.text}>{summary.bannerInput}</Typography> :
                <Typography marginTop={'10px'} className={styles.text}>- NA -</Typography>}
              </Grid>
              <Grid item xs={6} className={styles.summaryContainerRow}>
              <Typography className={styles.heading}>JPINs to display on banner</Typography>
              { jpinsExists ? 
              <Typography marginTop={'10px'} className={styles.text}>
              {summary.jpins ? summary.jpins : summary.jpinsOnBanner.join(',')}</Typography> :
              <Typography marginTop={'10px'} className={styles.text}>- NA -</Typography> }
            </Grid>
            {summary.plvCallOut && summary.score && (
            <>
             <Grid item xs={6} className={styles.summaryContainerRow}>
              <Typography className={styles.heading}>Product List Call-out</Typography>
              <Typography marginTop={'10px'} className={styles.text}>{summary.plvCallOut}</Typography>
            </Grid>
            <Grid item xs={6} className={styles.summaryContainerRow}>
              <Typography className={styles.heading}>Campaign Score</Typography>
              <Typography marginTop={'10px'} className={styles.text}>{summary.score}</Typography>
            </Grid>
            </>
            )}
          </Grid>
          <Grid item xs={4}>
            {summary.bannerUrl && 
              <img src={summary.bannerUrl} />
            }
          </Grid>  
          </Grid>
        </Paper>
        <Paper className={styles.paperContainer}>
        {!!comment && (
          <Grid container className={styles.summaryContainer}>
              <Grid item xs={12} className={styles.summaryContainerRow}>
                <Typography className={styles.heading}>Comment</Typography>
                <Typography marginTop={'10px'} className={styles.text}>{comment}</Typography>
              </Grid> 
            </Grid>
          )}
      </Paper>
        <Paper p="0px 26px 50px" extraRender={<Grid>
            <Grid container>
              {stateTransitionDTOList.map((trans) => (
                <Grid item xs={4} marginTop={'10px'} >
                  <Grid container alignItems={'baseline'}>
                    <Typography className={styles.transTitle}>{trans.userLabel}: </Typography>&nbsp;&nbsp;
                    <Typography className={styles.transValue}>{' '}{trans.user}</Typography>
                  </Grid>
                  <Grid container alignItems={'baseline'}>
                    <Typography className={styles.transTitle}>{trans.timeLabel}:</Typography>&nbsp;&nbsp;
                    <Typography className={styles.transValue}>
                      {moment(trans.time).format('DD/MM/YYYY - hh:mm a')}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid container marginTop={5} justifyContent='flex-end'>
              {possibleCTAs.map((button, index) => (
                <Grid item xs={2}>
                  <Button className={`${styles.button} ${index === possibleCTAs.length - 1 ? '' : styles.secButton}`} color={'primary'} variant={"contained"} onClick={() => onClickCTA(button)}>{button}</Button>
                </ Grid>
              ))}
            </Grid>    
        </Grid>} />
        {/* <Paper p="0px 26px 50px" extraRender={<Grid>
            <Grid container>
            <CampaignInfoTable campaignInfo={stateTransitionDTOList}/> 
            </Grid>
            <Grid container marginTop={5} justifyContent='flex-end'>
              {possibleCTAs.map((button, index) => (
                <Grid item xs={2}>
                  <Button className={`${styles.button} ${index === possibleCTAs.length - 1 ? '' : styles.secButton}`} color={'primary'} variant={"contained"} onClick={() => onClickCTA(button)}>{button}</Button>
                </ Grid>
              ))}
            </Grid>    
        </Grid>} /> */}
      </>}
      {currentTab === 1 && <Paper p="0px 26px 5px" sx={{ height: '80vh', width: "100%" }}>
        <div className={styles.tableauContainer}>
            <div>
                <tableau-viz
                    id="tableauViz"
                    src={src}
                >
                    <viz-filter
                        field="campaignid"
                        value={campaignId}
                    ></viz-filter>
                </tableau-viz>
            </div>
        </div>
      </Paper>}
    </Grid >
  );
}

export default CampaignSummary
